"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_SHIRT_SIZES = exports.UIComponentIcons = exports.ExcelExtensions = exports.WordExtensions = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _Document = _interopRequireDefault(require("../components/icons/Document"));

var _PDF = _interopRequireDefault(require("../components/icons/PDF"));

var _Video = _interopRequireDefault(require("../components/icons/Video"));

var _Image = _interopRequireDefault(require("../components/icons/Image"));

var WordExtensions = _immutable.default.Set(['doc', 'docx']);

exports.WordExtensions = WordExtensions;

var ExcelExtensions = _immutable.default.Set(['xls', 'xlsx', 'csv']);

exports.ExcelExtensions = ExcelExtensions;
var UIComponentIcons = [_Document.default, _Image.default, _PDF.default, _Video.default];
exports.UIComponentIcons = UIComponentIcons;
var ICON_SHIRT_SIZES = {
  xxs: 16,
  xs: 24,
  sm: 48,
  md: 64,
  lg: 72,
  xl: 96,
  xxl: 128,
  small: 16,
  medium: 32,
  large: 48
};
exports.ICON_SHIRT_SIZES = ICON_SHIRT_SIZES;